import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { ResidentModel } from '@/models'

interface SearchClientsRequest {
  buildingId: number
  query?: string
}

export const SEARCH_CLIENTS_BASE_QUERY_KEY = 'useSearchClients'
export const getSearchClientsQueryKey = (params: SearchClientsRequest) => [
  SEARCH_CLIENTS_BASE_QUERY_KEY,
  params,
]

export const searchClients = async (params: SearchClientsRequest, signal?: AbortSignal) => {
  const { buildingId, query } = params
  const url = `/client/0/100/${buildingId}/0${query ? `/${query}` : ''}`
  const response = await authAPI.get<ResidentModel[]>(url, { signal })
  return response.data
}

export const useSearchClients = (params: SearchClientsRequest) => {
  return useQuery({
    enabled: params.buildingId > 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => searchClients(params, signal),
    queryKey: getSearchClientsQueryKey(params),
  })
}
